/**
 * Pix QR generator para impressão térmica.
 *
 * Estratégia atual: usa um BR Code "Pix Estático" do Mercado Pago (instore/ol),
 * que aponta para a URL da MP via campo 26.25. O valor NÃO é embutido no payload
 * (MP resolve no servidor), então mostramos o valor como texto grande abaixo
 * do QR para o cliente conferir antes de pagar.
 *
 * O payload abaixo já está com CRC16 calculado e validado pelo BACEN/MP — não
 * tente alterar campos 54/52/etc sem recalcular o CRC.
 */

// BR Code "Pix Cobrança" Mercado Pago - Menezes Empreendimentos / SAO PAULO.
// Fornecido pelo lojista; reutilizável.
const KAVEN_PIX_PAYLOAD =
  '00020101021126770014BR.GOV.BCB.PIX2555pix-qr.mercadopago.com/instore/ol/v2/38n2nVROzJEuWdFLfv5204000053039865802BR5923Menezes Empreendimentos6009SAO PAULO62080504mpis630420AB';

export function getPixPayload() {
  return KAVEN_PIX_PAYLOAD;
}

/**
 * Gera DataURL PNG do QR Code Pix.
 * Tamanho ~300px é nítido em impressora térmica 203dpi (≈30mm impressos).
 * Retorna string vazia se a geração falhar (template degrada graciosamente).
 */
export async function getPixQRDataURL() {
  try {
    const QRCode = (await import('qrcode')).default;
    return await QRCode.toDataURL(getPixPayload(), {
      errorCorrectionLevel: 'M',
      margin: 1,
      width: 300,
      color: { dark: '#000000', light: '#FFFFFF' },
    });
  } catch (err) {
    console.warn('[pixQR] Falha ao gerar QR:', err);
    return '';
  }
}
